import { Stack, Text, VStack } from '@genial/components';
import React from 'react';

import { TextSkeleton } from '../../../../../AssetsLoading';
import { FixedIncomeSharedInfoTypes, FixedIncomeSharedInfoTypesLoading } from '../types';

export const TaxInfo: React.FC<FixedIncomeSharedInfoTypes> = ({ offer, w }) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">IR</Text>
        <Text>{offer.incomeTaxAmountNormalized}</Text>
      </VStack>
    </Stack>
  );
};

export const TaxInfoLoading: React.FC<FixedIncomeSharedInfoTypesLoading> = ({ w }) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">IR</Text>
        <TextSkeleton />
      </VStack>
    </Stack>
  );
};
